import ttspng from "@/images/service/tts.png";
import "./ttsItemInfo.less";
import classNames from "classnames";

const formatNum = (num: number) => {
  try {
    if (!num) return num;
    return num.toFixed(2);
  } catch (error) {
    return num;
  }
};

const getPercentColor = (percentStr: string) => {
  try {
    if (!percentStr) return "#56B43C";
    const percentNum = (percentStr as any).split("%")[0] - 0;
    if (percentNum > 50) return "#56B43C";
    if (percentNum < 30) return "#F60707";
    return "#FE8C33";
  } catch (error) {
    return "#56B43C";
  }
};

const TtsItemInfo = ({
  ttsInfo,
  className,
  children,
}: {
  ttsInfo: TTsInfo;
  className?: string;
  children?: JSX.Element;
}) => {
  return (
    <div className={classNames(["ttsinfo-item-wrapper", className])}>
      <h3>{ttsInfo.makeNum}</h3>
      <div className="unit-tips">
        <p style={{ width: 40 }}>
          <span>单位:</span>
        </p>
        <p>
          <span>m³ - 立方米</span>
          <span>TON - 吨</span>
        </p>
      </div>
      <div className="ttsinfo-item-content">
        <div className="info-left">
          <img src={ttspng} alt="" />
          <div className="info-content-wrapper">
            <div className="info-content flex-c-c">
              <p className="top">{ttsInfo.productName}</p>
              <div className="bottom">
                <p>{ttsInfo.percent}</p>
                <p>{formatNum(ttsInfo.currentWeight)}TON</p>
              </div>
            </div>
            <div
              className="capacity-percent"
              style={{
                height: ttsInfo.percent,
                backgroundColor: getPercentColor(ttsInfo.percent),
              }}
            ></div>
          </div>
        </div>
        <div className="info-right">
          <p>
            <span className="label">最大容量：</span>
            <span>
              {formatNum(ttsInfo.filledLevel)} m³ /{" "}
              {formatNum(ttsInfo.filledWeight)} TON
            </span>
          </p>
          <p>
            <span className="label">当前容积：</span>
            <span>
              {formatNum(ttsInfo.currentVolume)} m³ /{" "}
              {formatNum(ttsInfo.currentWeight)} TON
            </span>
          </p>
          <p>
            <span className="label">可充转量：</span>
            <span>
              {formatNum(ttsInfo.canVolume)} m³ / {formatNum(ttsInfo.canWeight)}{" "}
              TON
            </span>
          </p>
          <p>
            <span className="label">更新时间：</span>
            <span>{ttsInfo.dataSubmitTime}</span>
          </p>
          <p>
            <span className="label">储罐地址：</span>
            <span>{ttsInfo.servedAddress}</span>
          </p>
        </div>
      </div>
      {children ? children : <></>}
    </div>
  );
};

export default TtsItemInfo;
